import React, { useRef } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

import { InputContainer, InputContainerProps, InputElement } from './Input';

export type NumericInputProps = {
  id: string;
  error?: boolean;
  formattedSuffix?: string;
  formattedPrefix?: string;
} & NumericFormatProps &
  Omit<InputContainerProps, 'children'>;

export const NumericInput: React.FC<NumericInputProps> = ({
  suffix,
  prefix,
  formattedSuffix,
  formattedPrefix,
  error,
  disabled,
  ...props
}) => {
  // setup a ref so that if the user clicks on the padding of InputContainer we
  // can focus them onto our Input
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <InputContainer
      suffix={suffix}
      prefix={prefix}
      error={error}
      disabled={disabled}
      onClick={(event) => event.target !== inputRef.current && inputRef.current?.focus()}
    >
      <NumericFormat
        error={error}
        disabled={disabled}
        suffix={formattedSuffix}
        prefix={formattedPrefix}
        {...props}
        customInput={InputElement}
        getInputRef={inputRef}
      />
    </InputContainer>
  );
};
